import React, { Component } from "react";
import "./style.scss";
import PrimaryButton from "../../elements/primary-button";

const FloatingActionButton = props => {
  const { fields } = props;
  const { btnText, colorScheme, link } = fields;
  
  return (
    <div className="floating-action-btn">
      <PrimaryButton 
        buttonText={btnText}
        colorScheme={colorScheme}
        link={link}
      />
    </div>
  );
};

export default FloatingActionButton;

